import React, { useState } from "react";

// Define the namePattern for letter validation
const namePattern = /^[\p{L}\p{N}'.-]+(?: [\p{L}\p{N}'.@-]+)* ?$/u;

function TodoItem({ todo, updateTodo, deleteTodo, serial }) {
  const [editText, setEditText] = useState(todo.text); // Local state for editing text
  const [error, setError] = useState(""); // State to track error message

  const handleSave = () => {
    if (editText.trim().length === 0) {
      setError("Cannot be empty!");
      return;
    }

    if (editText.trim().length > 25) {
      setError("Exceeds 25 letters!");
      return;
    }

    if (!namePattern.test(editText)) {
      setError("Please use letters, numbers, and valid symbols ('.', '-', '@').");
      return;
    }

    setError(""); // Clear error if no issues
    updateTodo(todo.id, editText); // Update todo in the parent component
  };

  const handleChange = (e) => {
    let newText = e.target.value;

    // Capitalize only the first letter of each word and make others lowercase
    newText = newText
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());

    setEditText(newText); // Update the input text as the user types

    // Real-time validation: Check if the text exceeds 25 characters
    if (newText.trim().length > 25) {
      setError("Exceeds 25 letters!");
    } else if (!namePattern.test(newText)) {
      setError("Please use letters, numbers, and valid symbols ('.', '-', '@').");
    } else {
      setError(""); // Clear error if the length is within limit and pattern is valid
    }
  };

  return (
    <li
      style={{
        display: "grid",
        gridTemplateColumns: "auto 1fr auto auto",
        alignItems: "center",
        gap: "5px",
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f9f9f9",
        marginBottom: "10px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <span
        style={{
          fontWeight: "bold",
          textAlign: "center",
          backgroundColor: "#ffcccb",
          borderRadius: "4px",
          padding: "5px",
          minWidth: "20px",
        }}
      >
        {serial}.
      </span>

      {todo.isEditing ? (
        <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
          <input
            type="text"
            value={editText}
            onChange={handleChange}
            style={{
              padding: "5px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              flex: "1",
              minWidth: "0",
            }}
          />
          <button
            onClick={handleSave}
            style={{
              marginLeft: "10px",
              padding: "5px 10px",
              backgroundColor: "#1dd1a1",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              flexShrink: "0",
            }}
          >
            Save
          </button>
        </div>
      ) : (
        <span
          style={{
            padding: "5px",
            backgroundColor: "#d0f0c0",
            borderRadius: "4px",
            wordWrap: "break-word",
          }}
        >
          {todo.text}
        </span>
      )}

      {!todo.isEditing && (
        <>
          <button
            onClick={() => updateTodo(todo.id, todo.text, true)} // Trigger edit mode
            style={{
              padding: "5px 10px",
              backgroundColor: "#6c63ff",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Edit
          </button>

          <button
            onClick={() => deleteTodo(todo.id)}
            style={{
              padding: "5px 10px",
              backgroundColor: "#ff6b6b",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Delete
          </button>
        </>
      )}

      {error && (
        <div
          style={{
            color: "red",
            fontSize: "12px",
            marginTop: "5px",
            gridColumn: "1 / span 4", // Span across all columns to align the error below the input
          }}
        >
          {error}
        </div>
      )}
    </li>
  );
}

export default TodoItem;
